import { render, staticRenderFns } from "./Rice.vue?vue&type=template&id=4dca8d90&scoped=true&"
import script from "./Rice.vue?vue&type=script&lang=js&"
export * from "./Rice.vue?vue&type=script&lang=js&"
import style0 from "./Rice.vue?vue&type=style&index=0&id=4dca8d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca8d90",
  null
  
)

export default component.exports